import React from 'react';
import { observer } from 'mobx-react';

import { AntSelectProps } from 'controls/react/ant/antSelect';
import { tooltipOptions } from './constants';
import { AntSelectWithCustomOptions } from 'controls/react/AntSelectWithCustomOptions';

export type MetricTooltipSelectProps = AntSelectProps<string[]> & {};

export const MetricTooltipSelect = observer((props: MetricTooltipSelectProps) => {
	return <AntSelectWithCustomOptions {...props} options={tooltipOptions} />;
});
